import classNames from 'classnames';
import { forwardRef, useCallback, useEffect } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Checkbox, Dropdown, Tooltip, Whisper } from 'rsuite';
import { selectorOfferDataView, setAutoExpandOfferRows } from '../../../../../reducers/gerenciadorPrecos/offerDataView';
import { selectorQuickActionFilters, toggleQuickActionFilter } from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import styles from './OfferDataToggleButton.module.scss';

const OfferDataToggleButton = forwardRef<HTMLButtonElement>((_props, ref) => {
  const dispatch = useDispatch();
  const isOfferDataActive = useSelector(selectorQuickActionFilters).isOfferData.isActive;
  const { autoExpandRows } = useSelector(selectorOfferDataView);

  const isAutoExpandActive = isOfferDataActive && autoExpandRows;

  useEffect(() => {
    if (!isOfferDataActive && autoExpandRows) {
      dispatch(setAutoExpandOfferRows(false));
    }
  }, [autoExpandRows, dispatch, isOfferDataActive]);

  const handleMainClick = useCallback(() => {
    if (isOfferDataActive && autoExpandRows) {
      dispatch(setAutoExpandOfferRows(false));
    }

    dispatch(toggleQuickActionFilter({ key: 'isOfferData' }));
  }, [autoExpandRows, dispatch, isOfferDataActive]);

  const handleAutoExpandChange = useCallback(
    (_value: unknown, checked: boolean) => {
      if (checked && !isOfferDataActive) {
        dispatch(toggleQuickActionFilter({ key: 'isOfferData' }));
      }

      dispatch(setAutoExpandOfferRows(checked));
    },
    [dispatch, isOfferDataActive],
  );

  return (
    <ButtonGroup className={styles['offer-toggle']}>
      <Whisper speaker={<Tooltip>Exibir somente itens com Preço de Oferta</Tooltip>} placement="bottom">
        <Button
          ref={ref}
          onClick={handleMainClick}
          className={classNames(styles['offer-toggle__button'], styles['offer-toggle__button--main'], {
            [styles['offer-toggle__button--active']]: isOfferDataActive,
          })}
        >
          <strong className={styles['offer-toggle__number']}>3</strong>
          <span className={styles['offer-toggle__label']}>Oferta</span>
        </Button>
      </Whisper>

      <Dropdown
        placement="bottomEnd"
        className={classNames(styles['offer-toggle__dropdown'], isOfferDataActive && styles['offer-toggle__dropdown--active'])}
        renderTitle={() => <MdKeyboardArrowDown className={styles['offer-toggle__arrow']} />}
      >
        <Dropdown.Item panel className={styles['offer-toggle__panel']}>
          <Checkbox checked={isAutoExpandActive} onChange={handleAutoExpandChange}>
            Filtrar e exibir o preço oferta no grid
          </Checkbox>
        </Dropdown.Item>
      </Dropdown>
    </ButtonGroup>
  );
});

OfferDataToggleButton.displayName = 'OfferDataToggleButton';

export default OfferDataToggleButton;
